import { Base } from './base';
import { HtmlText } from './htmlText';
import { Permission } from './permission';
import { Todo } from './todo';
import { Unit } from './unit';
import { User, UserBase, UserRelationType } from './user';

export type Event = {
	Id: number;
	EventTypeId: number;
	CreatedByUserId: number;
	PortalId: number;
	CreatedDateUtc: Date;
	StartDateTimeUtc: Date;
	EndDateTimeUtc: Date;
	RSVPDateTimeUtc: Date;
	ExternalUrl: string;
	MaxParticipants: number;
	IsActive: boolean;
	OrganizerName: string;
	OrganizerEmail: string;
	OrganizerPhone: string;
	Status: EventStatus;
	IsExternal: boolean;
	CultureIds: number[];
	Name: string;
	Description: string;
	ShortDescription: string;
	Location: string;
	ImageUrl: string | null;
	InternalComment: string | null;
	DoNotRequireRSVP: boolean;
	ParticipantCount: number;
	UserStatus: ParticipationStatus;
	Todos: Todo[] | null;
	CoOrganizers: User[];
	CanParticipate: boolean;
	RelatedParticipationUserIds: number[] | null;
	HtmlTexts: HtmlText[] | null;
	Permissions: Permission[] | null;
};

export enum EventStatus {
	Upcoming = 0,
	Cancelled = 1,
	Completed = 2,
}

export enum ParticipationStatus {
	None = 0,
	Invited = 2,
	Attending = 3,
	NotAttending = 4,
	ConfirmedAttended = 5,
	Pending = 6,
}

export enum UpdateParticipationStatusResult {
	CannotFindEvent = 1,
	EventIsFull = 2,
	EventIsExternal = 3,
	RSVPDatePassed = 4,
	InvalidEmail = 5,
	StatusUpdateMailSent = 6,
	FailedToSendUpdateMail = 7,
}

export type EventParticipator = {
	Id: number;
	EventId: number;
	ParticipantUserId: number;
	Status: ParticipationStatus;
	ParticipantName: string;
	MainUserId: number | null;
	MainUserName: string | null;
	MainUserRelationType: UserRelationType | null;
	UserComment: string | null;
};

export type EventStatsEvent = {
	EventId: number;
	EventName: string;
	EventStart: Date;
	EventEnd: Date;
	RsvpStatus: string;
	AttendedCount: number;
	AttendedByUserRelationGroupsCount: number;
	AttendedByUserRelation: EventStatsByUserRelationCount[];
	AttendedByUserIds: number[];
	Permissions: Permission[];
	EventCategoryIds: number[];
};

export type EventStatsByUserRelationCount = {
	UserRelationSystemName: string;
	Count: number;
	UserIds: number[];
};

export type EventStats = {
	EventStats: EventStatsEvent[];
	TotalAttendedCount: number;
	AllAttendedUserIds: number[];
	TotalAttendedByUserRelationGroupCount: number;
	TotalUniqueAttendedByUserRelationGroupCount: number;
	UsersWAccess: EventUserStatsEntity[];
	DummyUsersWAccess: EventUserStatsEntity[];
	TotalAttendedByUserRelation: EventStatsByUserRelationCount[];
	TotalEventTimeInMinutes: number;
	TotalAttendedEventTimeInMinutes: number;
};

export interface EventUserStatsEntity extends UserBase {
	HasAttended: boolean;
	Units: Unit[] | null;
	AccessToEvents: number[] | null;
	AttendedEvents: number[] | null;
	AttendedEventsByRelationGroup: number[] | null;
}

export interface EventCategory extends Base {
	Order: number;
}
